<template>
    <div
        v-if="isShown"
        class="
            fixed
            top-1/2
            left-1/2
            z-50
            max-w-sm
            p-8
            text-white
            transform
            opacity-0
            bg-tertiary
            bg-blend-multiply
            bg-texture
            notification
        "
    >
        <button
            @click="close"
            type="button"
            class="
                absolute
                top-0
                right-0
                p-4
                text-xl
                text-black
                hover:text-primary
            "
        >
            &times;
        </button>

        <div v-html="content" />
    </div>
</template>

<script>
export default {
    name: 'UiNotification',
    props: {
        content: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            isShown: JSON.parse(sessionStorage.getItem('showNotification') || true),
        };
    },
    methods: {
        close() {
            this.isShown = false;
            sessionStorage.setItem('showNotification', false);
        },
    },
};
</script>

<style lang="scss" scoped>
    .notification {
        animation: animate-left 0.6s forwards;
        animation-delay: 0.3s;
    }

    @keyframes animate-left {
        0% {
            opacity: 100%;
            transform: translate(-100vw, -50%);
        }

        100% {
            opacity: 100%;
            transform: translate(-50%, -50%);
        }
    }
</style>
